/* eslint-disable import/prefer-default-export */
export const REDUCER_KEY = 'invoices'
export const ACTION_KEY = 'invoices/FETCH'
